<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <form [formGroup]="formUpload" autocomplete="nope"
    style="height: 400px; width: 100%;">
    <mat-form-field
      appearance="outline"
      style="width: 100%; margin-bottom: 3px !important;">
        <mat-label>Name</mat-label>
        <input matInput required autocomplete="off" readonly
          placeholder="File name"
          id="AttachmentName"
          name="AttachmentName"
          formControlName="AttachmentName">
    </mat-form-field>
    <div style="width: 100%;">
      <input #ebbFileInput  id="dialog-file-upload-input"
        style="display: none;"
        type="file" aria-hidden="true" title="file"
        onclick="this.value=null"
        (change)="ebbFileInputChange($event)"/>
    </div>

    <div style="margin-top: -18px !important;" ngClass.gt-sm="'buttonAlignContainer'">
      <button mat-flat-button color="accent" id="dialog-file-upload-button"
        style="margin-right:9px; min-width:135px;"
        ngStyle.lt-md="{'margin-bottom': '9px'}"
        (click)="ebbFileInput.click()">
        BROWSE FOR FILE
      </button>
      <button mat-flat-button color="accent"
        style="min-width:135px;"
        *ngIf="showRotateImage"
        (click)="rotateImageOrientation()">
        <mat-icon>rotate_right</mat-icon>
        ROTATE {{rotateDegree}}&deg;
      </button>
    </div>



    <div  style="width: 100%; display: block; float: left;">
      <p *ngIf="!fileError">{{displayFileName}}</p>
      <p *ngIf="fileError" class="mat-error"><mat-icon>warning</mat-icon> {{displayFileName}}</p>
    </div>

    <div style="width: 100%; display: block; float: left; margin-top: 9px;">
      <div *ngIf="!displayFileUrl" style="color: #727272;">
        <p>Only the following file types can be uploaded:</p>
        <ul>
          <li *ngIf='!data.isImage'>Adobe PDF</li>
          <li *ngIf='!data.isImage'>Microsoft Word DOCX</li>
          <li>Image JPG</li>
          <li>Image PNG</li>
        </ul>
        <p>The maximum file size is {{fileMaxSize}}MB.</p>
      </div>
      <div *ngIf="displayFileUrl">
        <div *ngIf="data.isImage" style="align-content: center; overflow: scroll;">
          <img [src]="displayFileUrl" style="height: 275px;" alt="uploaded file"/>
        </div>
        <div *ngIf="!data.isImage">
          <img [src]="displayFileUrl" style="height: 200px;" alt="uploaded file"/>
        </div>
      </div>

    </div>

  </form>
</div>
<div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">

  <button mat-button id="dialog-file-upload-cancel"
  (click)="onClickCancel()">
  CANCEL
  </button>
  <button mat-flat-button
  [mat-dialog-close]="data"
  color="primary" id="dialog-file-upload-save"
  [disabled]="disableFileSave">
  SAVE
</button>

</div>
